/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import "./ToastStyling.scss";
import * as React from "react";
import Toast from "./Toast";
export default class ToastMaster extends React.Component {
    constructor(props) {
        super(props);
        this.notify = this.notify.bind(this);
        this.closeAll = this.closeAll.bind(this);
        props.bindNotify(this.notify);
        props.bindCloseAll(this.closeAll);
        this.state = {
            toasts: [],
        };
        this.createToastInstance = this.createToastInstance.bind(this);
        this.removeToast = this.removeToast.bind(this);
    }
    /* Remove the specified toast from the state*/
    removeToast(id) {
        this.setState((prevState) => {
            return {
                toasts: prevState.toasts.filter((toast) => toast.id !== id),
            };
        });
    }
    /* Set isVisible to false in the specified Toast using ID*/
    closeToast(id) {
        this.setState((prevState) => {
            return {
                toasts: prevState.toasts.map((toast) => {
                    if (toast.id === id) {
                        return Object.assign(Object.assign({}, toast), { isVisible: false });
                    }
                    return toast;
                }),
            };
        });
    }
    render() {
        return (React.createElement("span", { className: "itwin-toast-wrapper" }, this.state.toasts.map((_a) => {
            var { id } = _a, props = __rest(_a, ["id"]);
            return (React.createElement(Toast, Object.assign({ key: id, onRemove: this.removeToast.bind(this, id) }, props)));
        })));
    }
    /* Return a ToastObject and add it into the state */
    notify(settings) {
        const instance = this.createToastInstance(settings);
        this.setState((prevState) => {
            return {
                toasts: [instance, ...prevState.toasts],
            };
        });
        return instance;
    }
    /* Set isVisible to false for every toast in the state*/
    closeAll() {
        this.state.toasts.forEach((toast) => {
            this.closeToast(toast.id);
        });
    }
    /* Create a ToastObject using settings passed in from Toaster */
    createToastInstance(settings) {
        const uid = ++ToastMaster.idCounter;
        return {
            category: settings.category,
            duration: settings.duration,
            hasCloseButton: settings.hasCloseButton,
            id: uid,
            isVisible: true,
            link: settings.link,
            text: settings.text,
            type: settings.type,
        };
    }
}
ToastMaster.idCounter = 0;
